import React, { useState, useEffect } from 'react';
import { FEATURES } from '../constants';

/**
 * Mobile Sticky Bottom Bar Component
 * Shows sticky checkout bar on mobile with price and action buttons
 */
const MobileStickyBar = ({ 
  price, 
  discount, 
  onAddToCart, 
  onBuyNow, 
  inStock = true,
  quantity = 1 
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!FEATURES.ENABLE_MOBILE_STICKY_BAR) {
      return;
    }

    const handleScroll = () => {
      // Show sticky bar when user scrolls past 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!FEATURES.ENABLE_MOBILE_STICKY_BAR) {
    return null;
  }

  const discountedPrice = discount > 0 
    ? price * (1 - discount / 100) 
    : price;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 bg-white border-t-2 border-gray-200 shadow-2xl z-40 md:hidden transition-transform duration-300 ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="px-4 py-3">
        <div className="flex items-center justify-between gap-3">
          {/* Price Section */}
          <div className="flex-shrink-0">
            <div className="flex flex-col">
              <span className="text-xs text-gray-500">Total Price</span>
              <div className="flex items-center gap-1">
                <span className="text-lg font-bold text-gray-900">
                  KES {Number(discountedPrice).toLocaleString()}
                </span>
                {discount > 0 && (
                  <span className="text-xs bg-red-500 text-white px-1.5 py-0.5 rounded">
                    -{discount}%
                  </span>
                )}
              </div>
              {discount > 0 && (
                <span className="text-xs text-gray-400 line-through">
                  KES {Number(price).toLocaleString()}
                </span>
              )}
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex gap-2 flex-1">
            <button
              onClick={onAddToCart}
              disabled={!inStock}
              className="flex-1 bg-yellow-400 hover:bg-yellow-500 disabled:bg-gray-300 disabled:text-gray-500 text-black font-semibold py-3 px-3 rounded-lg transition-colors duration-200 text-sm"
            >
              Add to Cart
            </button>
            <button
              onClick={onBuyNow}
              disabled={!inStock}
              className="flex-1 bg-orange-500 hover:bg-orange-600 disabled:bg-gray-300 disabled:text-gray-500 text-white font-semibold py-3 px-3 rounded-lg transition-colors duration-200 text-sm"
            >
              Buy Now
            </button>
          </div>
        </div>

        {/* Stock Status */}
        {!inStock && (
          <div className="mt-2 text-center text-xs text-red-600 font-medium">
            Out of Stock
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileStickyBar;
